import Bs4GenericField from './Bs4Fields/Bs4GenericField';
import Bs4AutoText from './Bs4Fields/Bs4AutoText';
import Bs4Button from './Bs4Fields/Bs4Button';
import Bs4Checkbox from './Bs4Fields/Bs4Checkbox';
import Bs4Color from './Bs4Fields/Bs4Color';
import Bs4Date from './Bs4Fields/Bs4Date';
import Bs4DateRange from './Bs4Fields/Bs4DateRange';
import Bs4DateTime from './Bs4Fields/Bs4DateTime';
import Bs4DateTimeRange from './Bs4Fields/Bs4DateTimeRange';
import Bs4Time from './Bs4Fields/Bs4Time';
import Bs4Timer from './Bs4Fields/Bs4Timer';
import Bs4File from './Bs4Fields/Bs4File';
import Bs41File from './Bs4Fields/Bs41File';
import Bs4FileList from './Bs4Fields/Bs4FileList';
import Bs4Gallery from './Bs4Fields/Bs4Gallery';
import Bs4HTMLany from './Bs4Fields/Bs4HTMLany';
import Bs4IFrame from './Bs4Fields/Bs4IFrame';
import Bs4Info from './Bs4Fields/Bs4Info';
import Bs4Mapa from './Bs4Fields/Bs4Mapa';
import Bs4Multiple from './Bs4Fields/Bs4Multiple';
import Bs4Number from './Bs4Fields/Bs4Number';
import Bs4NumberRange from './Bs4Fields/Bs4NumberRange';
import Bs4NumberSlider from './Bs4Fields/Bs4NumberSlider';
import Bs4Password from './Bs4Fields/Bs4Password';
import Bs4Radio from './Bs4Fields/Bs4Radio';
import Bs4Select from './Bs4Fields/Bs4Select';
import Bs4SimpleGrid from './Bs4Fields/Bs4SimpleGrid';
import Bs4Tabelka from './Bs4Fields/Bs4Tabelka';
import Bs4Text from './Bs4Fields/Bs4Text';
import Bs4Textarea from './Bs4Fields/Bs4Textarea';
import Bs4TextareaHtml from './Bs4Fields/Bs4TextareaHtml';
import Bs4Wykres from './Bs4Fields/Bs4Wykres';
import KontrolkaWybor from './Bs4Fields/KontrolkaWybor';
import WyborMultiple from './Bs4Fields/WyborMultiple';
import ZestawienieRozne from './Bs4Fields/ZestawienieRozne';
import Bs4InfinityGrid from './Bs4Fields/Bs4InfinityGrid';
import Bs4Empty from './Bs4Fields/Bs4Empty';
import Bs4Kanban from './Bs4Fields/Bs4Kanban';
import Bs4BoxCss from './Bs4Fields/Bs4BoxCss';
import Bs4IconSelect from './Bs4Fields/Bs4IconSelect';
import Bs4IconButSel from './Bs4Fields/Bs4IconButSel';
import Bs4TextSelect from './Bs4Fields/Bs4TextSelect';
import Bs4SelectSlider from './Bs4Fields/Bs4SelectSlider';
import Bs4ProgressSel from './Bs4Fields/Bs4ProgressSel';
import Bs4Widget from './Bs4Fields/Bs4Widget';
import Bs4Signature from './Bs4Fields/Bs4Signature';
import Bs4Variantic from './Bs4Fields/Bs4Variantic';
import Bs4VarianticNew from './Bs4Fields/Bs4VarianticNew';
import Bs4SaveVarNew from './Bs4Fields/Bs4SaveVarNew';
import Bs4SaveVar from './Bs4Fields/Bs4SaveVar';
import Bs4Login from './Bs4Fields/Bs4LoginField';
import Bs4ExtLogin from './Bs4Fields/Bs4ExtLoginField';
import Bs4OnOffSwitch from './Bs4Fields/Bs4OnOffSwitch';
import Bs4Avatar from './Bs4Fields/Bs4Avatar';

const components = {
  bs4GenericField:    Bs4GenericField,
  bs4AutoText: 				Bs4AutoText,
	bs4Button: 					Bs4Button,
	bs4Checkbox: 				Bs4Checkbox,
	bs4Color: 					Bs4Color,
	bs4Date: 						Bs4Date,
	bs4DateRange: 			Bs4DateRange,
	bs4DateTime: 				Bs4DateTime,
	bs4DateTimeRange: 	Bs4DateTimeRange,
  bs4Time: 	          Bs4Time,
  bs4Timer:           Bs4Timer,
	bs4File: 						Bs4File,
  bs41File: 					Bs41File,
	bs4FileList: 				Bs4FileList,
	bs4Gallery: 				Bs4Gallery,
	bs4HTMLany: 				Bs4HTMLany,
	bs4IFrame: 					Bs4IFrame,
	bs4Info: 						Bs4Info,
  // bs4Info: 						Bs4Time, //test
	bs4Mapa: 						Bs4Mapa,
	bs4Multiple: 				Bs4Multiple,
	bs4Number: 					Bs4Number,
	bs4NumberRange: 		Bs4NumberRange,
	bs4NumberSlider: 		Bs4NumberSlider,
	bs4Password: 				Bs4Password,
	bs4Radio: 					Bs4Radio,
	bs4Select: 					Bs4Select,
	bs4SimpleGrid: 			Bs4SimpleGrid,
	bs4Tabelka: 				Bs4Tabelka,
	bs4Text: 						Bs4Text,
	bs4Textarea: 				Bs4Textarea,
	bs4TextareaHtml: 		Bs4TextareaHtml,
	bs4Wykres: 					Bs4Wykres,
	KontrolkaWybor: 		KontrolkaWybor,
	WyborMultiple: 			WyborMultiple,
	ZestawienieRozne: 	ZestawienieRozne,
  bs4InfinityGrid:    Bs4InfinityGrid,
  bs4Kanban:          Bs4Kanban,
  bs4BoxCss:          Bs4BoxCss,
  bs4IconButSel:      Bs4IconButSel,
  bs4IconSelect:      Bs4IconSelect,
  bs4TextSelect:      Bs4TextSelect,
  bs4SelectSlider:    Bs4SelectSlider,
  bs4ProgressSel:     Bs4ProgressSel,
  bs4Widget:          Bs4Widget,
  bs4Signature:       Bs4Signature,
  bs4Variantic:       Bs4Variantic,
  bs4VarianticNew:    Bs4VarianticNew,
  bs4SaveVar:         Bs4SaveVar,
  bs4SaveVarNew:      Bs4SaveVarNew,
  bs4Login:           Bs4Login,
  bs4Login:           Bs4Login,
  bs4ExtLogin:        Bs4ExtLogin,
  bs4OnOffSwitch:     Bs4OnOffSwitch,
  bs4Avatar:          Bs4Avatar,
}

export default function formFieldBinding (props) {
  try {   
    // varianticCloudLibrary: 1 
    if (parseInt(window.localStorage.getItem('varianticCloudLibrary')) > 0) {      
      const oldXtype = props.field.xtype;
      if (props.field.xtype === 'bs4SaveVar') props.field.xtype = 'bs4SaveVarNew';
      if (props.field.xtype === 'bs4Variantic') props.field.xtype = 'bs4VarianticNew'
      if (oldXtype !== props.field.xtype) console.log('...formFieldBinding varianticCloudLibrary...', oldXtype, '=>', props.field.xtype)
    }
    if (parseInt(window.localStorage.getItem('fronttest')) > 0) {      
      const oldXtype = props.field.xtype;      
      if (oldXtype !== props.field.xtype) console.log('...formFieldBinding fronttest...', oldXtype, '=>', props.field.xtype)
    }

    return new components[props.field.xtype](props);
  } catch(error) {
    console.log('=== Error === formFieldBinding ', props)
    console.log(error)
    return new Bs4Empty(props);
  }
}
